// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import ResourceLinkViewModel from '../../../../viewModel/resource/ResourceLinkViewModel';
import DocumentResourceViewModel from '../../../../viewModel/resource/DocumentResourceViewModel';
import DocumentResourceDTO from '../../dto/resource/DocumentResourceDTO';

export default abstract class DocumentResourceModel extends BaseModel<DocumentResourceDTO> {
  /**
  * @type {int64}
  */
  get id() { return this.dto.id; }
  set id(value) { this.dto.id = value; }
  /**
  */
  get links() { return this.getArrayModels(() => this.dto.links, ResourceLinkViewModel)!; }
  set links(value) { this.setArrayModels(() => this.dto.links, value); }
  /**
  * @type {int64}
  */
  get creatorId() { return this.dto.creatorId; }
  set creatorId(value) { this.dto.creatorId = value; }
  /**
  */
  get creatorName() { return this.dto.creatorName; }
  set creatorName(value) { this.dto.creatorName = value; }
  /**
  * @type {date-time}
  */
  get created() { return this.dto.created; }
  set created(value) { this.dto.created = value; }
  /**
  * @type {int64}
  */
  get modifierId() { return this.dto.modifierId; }
  set modifierId(value) { this.dto.modifierId = value; }
  /**
  */
  get modifierName() { return this.dto.modifierName; }
  set modifierName(value) { this.dto.modifierName = value; }
  /**
  * @type {date-time}
  */
  get modified() { return this.dto.modified; }
  set modified(value) { this.dto.modified = value; }
  /**
  */
  get externalId() { return this.dto.externalId; }
  set externalId(value) { this.dto.externalId = value; }
  /**
  */
  get fileName() { return this.dto.fileName; }
  set fileName(value) { this.dto.fileName = value; }
  /**
  */
  get filePath() { return this.dto.filePath; }
  set filePath(value) { this.dto.filePath = value; }
  /**
  */
  get fileExtension() { return this.dto.fileExtension; }
  set fileExtension(value) { this.dto.fileExtension = value; }
  /**
  * @type {int64}
  */
  get contentLength() { return this.dto.contentLength; }
  set contentLength(value) { this.dto.contentLength = value; }
  /**
  */
  get contentType() { return this.dto.contentType; }
  set contentType(value) { this.dto.contentType = value; }
  /**
  */
  get originalFileName() { return this.dto.originalFileName; }
  set originalFileName(value) { this.dto.originalFileName = value; }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    value = Number.parseFloat(qs.id);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.id = value;
    value = Number.parseFloat(qs.creatorid);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.creatorId = value;
    this.dto.creatorName = qs.creatorname;
    this.dto.created = qs.created;
    value = Number.parseFloat(qs.modifierid);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.modifierId = value;
    this.dto.modifierName = qs.modifiername;
    this.dto.modified = qs.modified;
    this.dto.externalId = qs.externalid;
    this.dto.fileName = qs.filename;
    this.dto.filePath = qs.filepath;
    this.dto.fileExtension = qs.fileextension;
    value = Number.parseFloat(qs.contentlength);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.contentLength = value;
    this.dto.contentType = qs.contenttype;
    this.dto.originalFileName = qs.originalfilename;
  }
}
